module.exports = __webpack_public_path__ + "static/media/caution-icon.31e51988.svg";